import {createStyles, Theme} from "@material-ui/core";

export const EditTodoDialogStyle = (theme: Theme) => createStyles({
  // Same frame as the event dialogs; doubled to win over the shared dialog's padding.
  paper: {
    '&&': {
      margin: 'auto 8px',
      width: 'calc(100% - 16px)',
      maxWidth: '600px',
      padding: 0,
      gap: 0,
    },
  },
  body: {
    display: 'flex',
    padding: '0px 12px 12px',
  },
});



// WEBPACK FOOTER //
// ./src/components/todo/EditTodoDialog.style.ts